import React from 'react';

const EnrollmentExplanation = () => (
  <>
    <h2>Hágase Cliente VanTrust</h2>
    <p>
      Finalizado el proceso tendrás la capacidad de{' '}
      <b>
        comprar monedas como inversión o invertir en otros activos denominados en moneda extranjera
        a través del mercado spot.
      </b>
    </p>
    <p>
      Ofrecemos ejecución rápida, y precios competitivos para cubrir eficientemente sus
      importaciones y liquidar sus retornos en moneda extranjera.
    </p>
  </>
);

export default EnrollmentExplanation;
